(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9527],{

/***/ 53223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _CMSCard_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58337);
/* harmony import */ var _CMSCard_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_CMSCard_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function CMSCard(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
    className: (_CMSCard_module_scss__WEBPACK_IMPORTED_MODULE_1___default().card),
    children: children
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (CMSCard);

/***/ }),

/***/ 92536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomMetaHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function CustomMetaHead(_ref) {
  var children = _ref.children,
      meta = _ref.meta;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [meta.title, " | ", "SUPERMARKET Κρητικός"]
    }), children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: meta.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "keywords",
      content: meta.keywords
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "index, follow"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:title",
      content: "".concat(meta.title, " | ").concat("SUPERMARKET Κρητικός")
    }, "title"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:url",
      content: meta.url
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image",
      content: meta.image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:width",
      content: "1080"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:height",
      content: "1080"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:alt",
      content: meta.alt
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:description",
      content: meta.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:site_name",
      content: meta.alt
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:type",
      content: "website"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "canonical",
      content: meta.url
    })]
  });
}

/***/ }),

/***/ 29962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13764);
/* harmony import */ var _Buttons_Buttons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3805);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61429);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var CUSTOM_STYLES_V2 = {
  overlay: _objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__/* ["default"].overlay */ .Z.overlay),
  content: _objectSpread(_objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__/* ["default"].content */ .Z.content), {}, {
    outline: '0'
  })
};

function GenericModalV2(_ref) {
  var children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      _ref$mainText = _ref.mainText,
      mainText = _ref$mainText === void 0 ? '' : _ref$mainText,
      modalLabel = _ref.modalLabel,
      onClickContinue = _ref.onClickContinue,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Συνέχεια' : _ref$submitText;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isOpen),
      _isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _onClickContinue = onClickContinue || closeModal;

  function closeModal() {
    setIsModalOpen(false);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_2___default()), {
    isOpen: _isModalOpen,
    style: CUSTOM_STYLES_V2,
    contentLabel: modalLabel,
    ariaHideApp: false,
    className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalContent),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalContainer),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("main", {
        children: children || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
          children: mainText
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("footer", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_4__/* .PrimaryButton */ .KM, {
          onClick: _onClickContinue,
          children: [" ", submitText]
        })
      })]
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = (GenericModalV2);

/***/ }),

/***/ 55686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _CMSCard_CMSCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53223);
/* harmony import */ var _GenericModalV2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29962);
/* harmony import */ var _Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97844);
/* harmony import */ var _Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








function Newsletter(_ref) {
  var clubCard = _ref.clubCard;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      openModal = _useState[0],
      setOpenModal = _useState[1];

  var sideBarText = clubCard ? 'Θέλεις να μην χάνεις ευκαιρία να κερζίζεις; Γράψου στο Newsletter μας!' : "\u0398\u03AD\u03BB\u03B5\u03B9\u03C2 \u03BD\u03B1 \u03BC\u03B1\u03B8\u03B1\u03AF\u03BD\u03B5\u03B9\u03C2 \u03C4\u03B1 \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u03BD\u03AD\u03B1 \u03C4\u03B7\u03C2 ".concat("ΚΡΗΤΙΚΟΣ", ";");
  var success = "\u0395\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03B1\u03C2 \u03C3\u03C4\u03BF Newsletter \u03C4\u03C9\u03BD Supermarket ".concat("ΚΡΗΤΙΚΟΣ");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_CMSCard_CMSCard__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h5", {
        className: (_Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
        children: sideBarText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("form", {
        className: (_Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4___default().group),
        action: "//www.contactpigeon.com/apps/en/stem/subscribe.html/",
        method: "post",
        name: "form_sf_8874",
        onSubmit: function onSubmit() {
          return setOpenModal(true);
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          type: "hidden",
          value: "8874",
          name: "gm_pid"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("label", {
          htmlFor: "sfemail"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          className: (_Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4___default().input),
          type: "email",
          placeholder: "\u03A4\u03BF email \u03C3\u03BF\u03C5",
          id: "sfemail",
          name: "sfemail",
          required: true
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          type: "submit",
          name: "regme",
          className: (_Newsletter_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button),
          value: "\u0395\u0393\u0393\u03A1\u0391\u03A6\u0397"
        })]
      })]
    }), openModal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_GenericModalV2__WEBPACK_IMPORTED_MODULE_2__["default"], {
      mainText: success,
      isOpen: openModal,
      modalLabel: "Info modal"
    })]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (Newsletter);

/***/ }),

/***/ 21054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SidebarCMS_SidebarCMS; }
});

// EXTERNAL MODULE: ./src/components/CMSCard/CMSCard.jsx
var CMSCard = __webpack_require__(53223);
// EXTERNAL MODULE: ./src/components/DownloadApp/DownloadApp.jsx
var DownloadApp = __webpack_require__(27325);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Sidebar/GenericCategories.module.scss
var GenericCategories_module = __webpack_require__(58295);
var GenericCategories_module_default = /*#__PURE__*/__webpack_require__.n(GenericCategories_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Sidebar/GenericCategories.jsx









function Categories(_ref) {
  var _ref$page = _ref.page,
      page = _ref$page === void 0 ? 1 : _ref$page,
      _ref$categories = _ref.categories,
      categories = _ref$categories === void 0 ? [] : _ref$categories,
      contentName = _ref.contentName,
      categoryTitle = _ref.categoryTitle;
  if (!categories.length) return null;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CMSCard/* default */.Z, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
      className: (GenericCategories_module_default()).title,
      children: categoryTitle || 'Κατηγορίες'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (GenericCategories_module_default()).categories,
      children: categories.map(function (category) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/".concat(contentName, "?page=").concat(page, "&category=").concat(category.slug),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: classnames_default()((0,defineProperty/* default */.Z)({}, (GenericCategories_module_default()).active, router.asPath.includes(category.slug))),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
              className: "mdi mdi-chevron-right"
            }), category.title]
          })
        }, category.uuid);
      })
    })]
  });
}

/* harmony default export */ var GenericCategories = (Categories);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/config/index.js + 2 modules
var config = __webpack_require__(65599);
;// CONCATENATED MODULE: ./src/api/News.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var NEWS_PER_PAGE = 3;

function getNews(_x) {
  return _getNews.apply(this, arguments);
}

function _getNews() {
  _getNews = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(params) {
    var _yield$cms$get, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return config/* cms.get */.I.get('', {
              params: _objectSpread({
                contentType: 'news'
              }, params)
            });

          case 2:
            _yield$cms$get = _context.sent;
            data = _yield$cms$get.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getNews.apply(this, arguments);
}

function getList() {
  return _getList.apply(this, arguments);
}

function _getList() {
  _getList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var page,
        skip,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            page = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 1;
            skip = page > 1 ? (Number(page) - 1) * NEWS_PER_PAGE : undefined;
            return _context2.abrupt("return", getNews({
              limit: NEWS_PER_PAGE,
              skip: skip,
              withLinks: true
            }));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getList.apply(this, arguments);
}

function getNewsPage(_x2) {
  return _getNewsPage.apply(this, arguments);
}

function _getNewsPage() {
  _getNewsPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
    var slug;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            slug = _ref.slug;
            return _context3.abrupt("return", getNews({
              slug: slug
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getNewsPage.apply(this, arguments);
}

function getLatest() {
  return _getLatest.apply(this, arguments);
}

function _getLatest() {
  _getLatest = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", getNews({
              limit: 4
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getLatest.apply(this, arguments);
}
// EXTERNAL MODULE: ./src/utils/dayjs.js
var dayjs = __webpack_require__(95286);
// EXTERNAL MODULE: ./src/components/Sidebar/LatestNews.module.scss
var LatestNews_module = __webpack_require__(80935);
var LatestNews_module_default = /*#__PURE__*/__webpack_require__.n(LatestNews_module);
;// CONCATENATED MODULE: ./src/components/Sidebar/LatestNews.jsx









function LatestNews() {
  var _useState = (0,react.useState)([]),
      data = _useState[0],
      setData = _useState[1];

  (0,react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var contentType, res;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                contentType = 'news';
                _context.next = 3;
                return getLatest(contentType);

              case 3:
                res = _context.sent;
                setData(res.data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    try {
      fetchData();
    } catch (error) {
      console.log(error);
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (LatestNews_module_default()).latestNewsContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
      className: (LatestNews_module_default()).title,
      children: "\u03A4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B5\u03C2 \u0394\u03B7\u03BC\u03BF\u03C3\u03B9\u03B5\u03CD\u03C3\u03B5\u03B9\u03C2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: data.map(function (news, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (LatestNews_module_default()).twoLineList,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "".concat(news.slug),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (LatestNews_module_default()).newsTitle,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
                children: news.title
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (LatestNews_module_default()).latestNewsText,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
              className: "mdi mdi-calendar-text"
            }), (0,dayjs/* formatDate */.p6)(news.ct, 'L')]
          }), index < data.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {})]
        }, news.uuid);
      })
    })]
  });
}
// EXTERNAL MODULE: ./src/components/Sidebar/Newsletter.jsx
var Newsletter = __webpack_require__(55686);
// EXTERNAL MODULE: ./src/components/SidebarCMS/SidebarCMS.module.scss
var SidebarCMS_module = __webpack_require__(82269);
var SidebarCMS_module_default = /*#__PURE__*/__webpack_require__.n(SidebarCMS_module);
;// CONCATENATED MODULE: ./src/components/SidebarCMS/SidebarCMS.jsx









function SidebarCMS(_ref) {
  var categories = _ref.categories,
      contentName = _ref.contentName,
      categoryTitle = _ref.categoryTitle,
      appLinks = _ref.appLinks,
      _ref$isSingleNews = _ref.isSingleNews,
      isSingleNews = _ref$isSingleNews === void 0 ? false : _ref$isSingleNews;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SidebarCMS_module_default()).sidebar,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GenericCategories, {
      categories: categories,
      contentName: contentName,
      categoryTitle: categoryTitle
    }),  true && /*#__PURE__*/(0,jsx_runtime.jsx)(Newsletter/* default */.Z, {}), contentName !== 'news' && true && /*#__PURE__*/(0,jsx_runtime.jsx)(CMSCard/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DownloadApp/* default */.Z, {
        appLinks: appLinks,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (SidebarCMS_module_default()).downloadAppTitle,
          children: "\u039A\u0391\u03A4\u0395\u0392\u0391\u03A3\u0395 \u03A4\u039F APP"
        })
      })
    }), isSingleNews && contentName === 'news' && /*#__PURE__*/(0,jsx_runtime.jsx)(LatestNews, {})]
  });
}

/* harmony default export */ var SidebarCMS_SidebarCMS = (SidebarCMS);

/***/ }),

/***/ 13764:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var CUSTOM_STYLES = {
  overlay: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9,
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
  },
  content: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate3d(-50%, -50%, 0)',
    padding: 0,
    right: 'unset',
    bottom: 'unset'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (CUSTOM_STYLES);

/***/ }),

/***/ 58337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"CMSCard_card__H1j4b"};

/***/ }),

/***/ 61429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"GenericModalV2_modalContainer__aCXv8","modalContent":"GenericModalV2_modalContent__Mpl98","text":"GenericModalV2_text__vXm9C","footer":"GenericModalV2_footer__YXTWC","btn":"GenericModalV2_btn__rhKmF"};

/***/ }),

/***/ 50452:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidebar-card-list":"LayoutDynamic_sidebar-card-list__GSnVc","column":"LayoutDynamic_column__z3E6d","card":"LayoutDynamic_card__Ec1e2","img":"LayoutDynamic_img__3YqTm","body":"LayoutDynamic_body__yvI_v","title":"LayoutDynamic_title__PKs6u","meta":"LayoutDynamic_meta__iT6Fc","tags":"LayoutDynamic_tags__7e0fi","tagsInfo":"LayoutDynamic_tagsInfo__LD5qg","calendarIcon":"LayoutDynamic_calendarIcon__5TpYq","text":"LayoutDynamic_text___m7s6","more":"LayoutDynamic_more__SlJUj","pagination":"LayoutDynamic_pagination___FXWh","paginationLink":"LayoutDynamic_paginationLink__n5rCs","sr":"LayoutDynamic_sr__BqcTg","active":"LayoutDynamic_active__mo_DW","disabled":"LayoutDynamic_disabled__Z5z0Q","aside":"LayoutDynamic_aside__rqgNs"};

/***/ }),

/***/ 58295:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"GenericCategories_title__oCI5I","categories":"GenericCategories_categories__TrhnO","active":"GenericCategories_active__OL9in"};

/***/ }),

/***/ 80935:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"latestNewsContainer":"LatestNews_latestNewsContainer__hYK_s","title":"LatestNews_title__Esjn6","newsTitle":"LatestNews_newsTitle__c72UX","latestNewsText":"LatestNews_latestNewsText__JPd6W","twoLineList":"LatestNews_twoLineList__1O3ze"};

/***/ }),

/***/ 97844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Newsletter_title__I8Mqt","group":"Newsletter_group__JpG9b","input":"Newsletter_input__3socT","button":"Newsletter_button__atuwY"};

/***/ }),

/***/ 82269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SidebarCMS_sidebar__t4pJm","card":"SidebarCMS_card__AxG2D","downloadAppTitle":"SidebarCMS_downloadAppTitle__s6TtN"};

/***/ }),

/***/ 65447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"brandFontFamily":"\"Roboto\",Helvetica,Arial,sans-serif","container":"layout_container__8mgcn","section":"layout_section__q1Enk","row":"layout_row___Mosi"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ })

}]);